import React, { useContext } from "react";
import { SlSettings } from "react-icons/sl";
import { LuSettings } from "react-icons/lu";
import Modal from "../../interface/Modal";
import ButtonIcon from "../../interface/ButtonIcon";
import SettingsForm from "./SettingsForm";

function Settings() {
  return (
    <div>
      <Modal>
        <Modal.Open opens="settings">
          <ButtonIcon>
            <LuSettings />
          </ButtonIcon>
        </Modal.Open>
        <Modal.Window name="settings">
          <SettingsForm />
        </Modal.Window>
      </Modal>
    </div>
  );
}

export default Settings;
